export const changeLocation = (link: string) => window.open(link, '_newtab');

export const isUserVerifyingEmail = () => location.pathname.toLowerCase().match(/\/verification?/g);

export const isUserConfirmingEmail = () =>
  location.pathname.toLowerCase().match(/\/confirmation?/g) ? true : false;
